import { dynamic } from '#/utils/dynamic';

export const staffCmsModalComponentByType = {
  SELECT_CONTENT_BLOCK: dynamic(
    () =>
      import('./SelectContentBlock/SelectContentBlockModalContainer').then(
        (module) => ({ default: module.SelectContentBlockModalContainer }),
      ),
    { strategy: 'always' },
  ),
  DELETE_SUBSITE: dynamic(
    () =>
      import('./DeleteSubsite/StaffCmsDeleteSubsiteModal').then((module) => ({
        default: module.StaffCmsDeleteSubsiteModal,
      })),
    { strategy: 'always' },
  ),
  DUPLICATE_CONTENT: dynamic(
    () =>
      import('./DuplicateContent/StaffCmsDuplicateContentModalContainer').then(
        (module) => ({
          default: module.StaffCmsDuplicateContentModalContainer,
        }),
      ),
    { strategy: 'always' },
  ),
} as const satisfies Record<string, unknown>;
